/**
 * CareStart TTS persona defaults and selectable voices (Settings gear + facade).
 */

export const CARESTART_TTS_PROVIDER = Object.freeze({
  OPENAI: 'openai',
  GEMINI_FLASH_TTS: 'gemini_flash_tts',
  DEEPGRAM: 'deepgram',
});

/** Default CareStart spoken persona (classic + Plus HPI + CareStart3 OpenAI path). */
export const CARESTART_DEFAULT_TTS_PROVIDER = CARESTART_TTS_PROVIDER.OPENAI;
export const CARESTART_DEFAULT_OPENAI_VOICE = 'nova';
export const CARESTART_DEFAULT_DEEPGRAM_VOICE = 'asteria';
export const CARESTART_DEFAULT_TTS_MODEL = 'gpt-4o-mini-tts';
export const CARESTART_DEFAULT_TTS_SPEED = 0.95;

/** OpenAI voices offered in CareStart Settings (classic TTS path). */
export const CARESTART_OPENAI_VOICES = Object.freeze({
  alloy: { gender: 'neutral', description: 'Balanced voice' },
  echo: { gender: 'male', description: 'Warm male voice' },
  fable: { gender: 'male', description: 'British male voice' },
  onyx: { gender: 'male', description: 'Deep male voice' },
  nova: { gender: 'female', description: 'Friendly female voice' },
  shimmer: { gender: 'female', description: 'Clear female voice' },
});

/** Deepgram Aura-1 voices offered in CareStart Settings. */
export const CARESTART_DEEPGRAM_VOICES = Object.freeze({
  asteria: { gender: 'female', description: 'Default female voice' },
  luna: { gender: 'female', description: 'Soft female voice' },
  stella: { gender: 'female', description: 'Clear female voice' },
  athena: { gender: 'female', description: 'British female voice' },
  hera: { gender: 'female', description: 'Warm female voice' },
  orion: { gender: 'male', description: 'Default male voice' },
  arcas: { gender: 'male', description: 'Deep male voice' },
  perseus: { gender: 'male', description: 'Authoritative male voice' },
  angus: { gender: 'male', description: 'Irish male voice' },
  orpheus: { gender: 'male', description: 'Melodic male voice' },
  helios: { gender: 'male', description: 'British male voice' },
  zeus: { gender: 'male', description: 'Commanding male voice' },
});

export const CARESTART_TTS_GENERATION_TIMEOUT_MS = 20_000;
export const CARESTART_TTS_GENERATION_MAX_ATTEMPTS = 2;
